import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getScimTokens = api(async function getScimTokens({ clientId } = {}) {
    return await query(
        gql`
            query getScimTokens($clientId: String) {
                getScimTokens(clientId: $clientId) {
                    _id
                    prefix
                    createdAt
                    createdBy
                    lastUsedAt
                    revokedAt
                    note
                }
            }
        `,
        { clientId },
        { returns: "getScimTokens", fetchPolicy: "network-only" }
    )
})
